var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-5e699234"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-483f0ae0"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-5980312b"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-33b71d87"
	],
	"./amplify-chatbot.entry.js": [
		"9b2c",
		"chunk-a7ab836e"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		"e862",
		"chunk-a29b90be"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-3df93d1a"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-35d5ca8f"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-2d22dbc9"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-627a241e"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5bb031e"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-2394cb10"
	],
	"./amplify-photo-picker.entry.js": [
		"c4f1",
		"chunk-d4b4de5e"
	],
	"./amplify-picker.entry.js": [
		"d040",
		"chunk-d4b41fc6"
	],
	"./amplify-radio-button_2.entry.js": [
		"a4b9",
		"chunk-0d1060fc"
	],
	"./amplify-s3-album.entry.js": [
		"4e6f",
		"chunk-667538b2"
	],
	"./amplify-s3-image-picker.entry.js": [
		"b90a",
		"chunk-a708e4c0"
	],
	"./amplify-s3-image.entry.js": [
		"76ad",
		"chunk-eb358636"
	],
	"./amplify-s3-text-picker.entry.js": [
		"5af2",
		"chunk-533e6860"
	],
	"./amplify-s3-text.entry.js": [
		"dce0",
		"chunk-0dfee8be"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-d5523222"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f969a952"
	],
	"./amplify-toast.entry.js": [
		"05e3",
		"chunk-2d0a4629"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;